import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import { eventDetailsData } from 'sections/Events/GlobalFreightSummit2023/data';
import { EventDetails } from 'sections/Events/components/EventDetails/EventDetails';
import styles from 'sections/Events/GlobalFreightSummit2023/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mode="light"
          links={[
            { title: 'Events', href: '/events' as Route },
            { title: 'Global Freight Summit 2023', href: '' as Route },
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__description')}>
            <p className={cn('header__description-suptitle')}>events</p>
            <h1 className={cn('header__description-title')}>Global Freight Summit 2023</h1>
          </div>
          <div className={cn('header__event-details-wrap')}>
            <EventDetails eventDetailsData={eventDetailsData}/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;
